'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_string_prepend = require('./prepend.js');

var UPPERCASE_LETTERS_REGEX = /[A-Z]/g;

var toSnakeCase = function toSnakeCase(str) {
  if (!str) {
    return '';
  }

  var firstLetter = str[0];
  var rest = str.slice(1, str.length).replace(UPPERCASE_LETTERS_REGEX, utils_string_prepend['default']('_'));
  return "".concat(firstLetter).concat(rest).toLowerCase();
};

exports.default = toSnakeCase;
//# sourceMappingURL=toSnakeCase.js.map
